// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"420":"71d109c9","437":"4827c45c","679":"71d109c9"}[chunkId] + ".chunk.css";
};